﻿/**
 * workbench-history.js
 * Maintains an in-memory record of recent Workbench runs.
 */
export class WorkbenchHistory {
  constructor({ limit = 50 } = {}) {
    this.limit = typeof limit === 'number' && limit > 0 ? limit : 50;
    this.entries = [];
  }

  record(entry = {}) {
    const normalized = {
      id: entry.id || 'wb-' + Date.now() + '-' + Math.random().toString(16).slice(2, 10),
      tool: entry.tool || null,
      teamId: entry.teamId || null,
      source: entry.source || 'service',
      fallback: Boolean(entry.fallback),
      placeholder: Boolean(entry.placeholder),
      payload: entry.payload && typeof entry.payload === 'object' ? entry.payload : {},
      attachmentsCount:
        typeof entry.attachmentsCount === 'number' && !Number.isNaN(entry.attachmentsCount)
          ? entry.attachmentsCount
          : 0,
      meta: entry.meta && typeof entry.meta === 'object' ? entry.meta : null,
      timestamp: entry.timestamp || new Date().toISOString(),
    };

    this.entries.push(normalized);
    if (this.entries.length > this.limit) {
      this.entries.shift();
    }

    return normalized;
  }

  list() {
    return this.entries.slice();
  }

  latest() {
    return this.entries[this.entries.length - 1] || null;
  }

  clear() {
    this.entries.length = 0;
  }
}

if (typeof window !== 'undefined') {
  window.AgilePro = window.AgilePro || {};
  window.AgilePro.Helpers = window.AgilePro.Helpers || {};
  window.AgilePro.Helpers.WorkbenchHistory = WorkbenchHistory;
}
